import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { Alert, AlertAdapter } from "../models/alert.model";
import { HydraoApiService } from "./core/hydrao-api.service";

@Injectable({
  providedIn: "root",
})
export class AlertService extends HydraoApiService<Alert> {
  private alertAdapter: AlertAdapter = inject(AlertAdapter);

  public getAlertsForStore(): Observable<Alert[]> {
    let url = `/alerts`;

    return this.get(url, this.alertAdapter, false, true) as Observable<Alert[]>;
  }

  // public getLastAlertsForStore(limit: number): Observable<Alert[]> {
  //   let url = `/anomalies?limit=${limit}&order_by=anomaly.begin_date&direction=desc`;

  //   return this.get(url, this.alertAdapter, false, true) as Observable<Alert[]>;
  // }

  // public getLastAlerts(limit: number): Observable<Alert[]> {
  //   let url = `/anomalies?limit=${limit}&order_by=anomaly.begin_date&direction=desc`;
  //   this._cachedUrls.add(url);
  //   return this.get(url, this.alertAdapter) as Observable<Alert[]>;
  // }

  // public getMeterAlertDetails(anomalyId: number): Observable<Alert> {
  //   let url = `/anomalies/meter/${anomalyId}`;
  //   return this.get(url, this.alertAdapter, false) as Observable<Alert>;
  // }

  // public getGatewayAlertDetails(anomalyId: number): Observable<Alert> {
  //   let url = `/anomalies/gateway/${anomalyId}`;
  //   return this.get(url, this.alertAdapter, false) as Observable<Alert>;
  // }

  // /**
  //  * Return places
  //  */
  // public getAlertsPaginated(
  //   placeId = null,
  //   limit = null,
  //   offset = null,
  //   sortColumn = null,
  //   sortDirection = null
  // ): Observable<AlertPage> {
  //   let url = "/anomalies";

  //   let params = [];

  //   if (placeId) {
  //     params.push(`place=${placeId}`);
  //   }

  //   if (limit) {
  //     params.push(`limit=${limit}`);
  //   }
  //   if (offset) {
  //     params.push(`offset=${offset}`);
  //   }
  //   if (sortColumn) {
  //     params.push(`order_by=${sortColumn}`);
  //   }
  //   if (sortDirection) {
  //     params.push(`direction=${sortDirection}`);
  //   }

  //   if (params.length > 0) url += "?" + params.join("&");

  //   this._cachedUrls.add(url);

  //   return this.getWithHeaders(url, this.alertAdapter).pipe(
  //     map((resp: ResponseWithHeaders<Alert[]>) => {
  //       let contentRange = resp.headers.get("content-range");
  //       let count = resp.data.length;
  //       if (contentRange) {
  //         let match = contentRange.match(/\d*-\d*\/(\d*)/);

  //         if (match.length > 0 && !isNaN(Number(match[1]))) {
  //           count = parseInt(match[1]);
  //         }
  //       }

  //       return new AlertPage(resp.data, count);
  //     })
  //   );
  // }
}
